import styled from "styled-components";

export const TeamContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export const TeamMember = styled.div`
  background-color: #f2f2f2;
  border-radius: 8px;
  padding: 20px;
  margin: 10px;
  text-align: center;
`;

export const TeamMemberName = styled.h2`
  font-size: 1.2rem;
  color: #333;
  margin-bottom: 10px;
`;

export const TeamMemberPosition = styled.h3`
  font-size: 1rem;
  color: #777;
`;